import React, { useContext, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import MyInput from "../../Reusable/MyInput";
import Button from "../../Reusable/Button";
import toast from "react-hot-toast";
import MyTextarea from "../../Reusable/MyTextarea";
import { BaseURL } from "../../Reusable/BaseURL";
import ItemCategoryPageForm from "../../masterFormPages/ItemCategoryPageForm";
import MaterialTypePageForm from "../../masterFormPages/MaterialTypePageForm";

export default function MaterialType() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  // create Brand
  async function createDivision(e) {
    e.preventDefault();
    setSubmitDisable(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", desc);

    const res = await fetch(`${BaseURL}/material-types`, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          setName("");
          setDesc("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.name) {
          toast.error(createRes.error.message.name);
        } else if (createRes?.error?.message.description) {
          toast.error(createRes.error.message.description);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/material-types?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setTo(li.data.to);
          setFrom(li.data.from);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    if(editData){
      setEditDisable(true);
      setSubmitAction("update");
      setName(editData.name || "");
      setDesc(editData.description || "");
      setEditDisable(false);

      // TOP SCROLLING ==========
      // const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // You can use 'auto' instead of 'smooth' for instant scrolling
        });
      // };
      toast.success("Go to update form")
    }
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    const formData = { name: name, description: desc };
    const updRes = await fetch(`${BaseURL}/material-types/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setName("");
          setDesc("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.satus === false) {
          setUpdateDisable(false);
        }
        if (upd?.error?.message.name) {
          toast.error(upd.error.message.name);
        } else if (upd?.error?.message.description) {
          toast.error(upd.error.message.description);
        }
      });
  }
  function cancelFun() {
    setSubmitAction("submit");
    setName("");
    setDesc("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false)
    setEditDisable(false)
  }
  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Material Type Master
          </div>
          <div
            // className="grid grid-cols-1 gap-8 md:gap-1 lg:gap-4 md:grid-cols-2"
            className="flex flex-col gap-8 md:flex-row md:gap-1 lg:gap-4"
          >
            {allPermiss?.includes("master-item-materialtype-create") && <div className="w-full px-2 md:w-1/4">
              <form action="">
                <MyInput
                  label="Material type Name"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full"
                  mendatory="*"
                />
                <MyTextarea
                  label="Description"
                  type="text"
                  className="w-full"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />

                {allPermiss?.includes("master-item-materialtype-create") && submitAction === "submit" && (
                  <div className="flex items-center justify-start gap-x-1">
                    <Button
                      disabled={submitDisable}
                      type="submit"
                      onClick={(e) => createDivision(e)}
                    >
                      {submitDisable ? "Wait.." : "Submit"}
                    </Button>
                    <Button type="button" onClick={() => cancelFun()}>
                      Clear
                    </Button>
                  </div>
                )}
                {allPermiss?.includes("master-item-materialtype-update") && submitAction === "update" && (
                  <div className="flex items-center justify-start gap-x-1">
                    <Button
                      disabled={updateDisable}
                      type="submit"
                      onClick={(e) => updateARecord(e, getId)}
                    >
                      {updateDisable ? "Wait.." : "Update"}
                    </Button>
                    <Button
                      onClick={() => {
                        setSubmitAction("submit");
                        setName("");
                        setDesc("");
                        setGetId(0);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                )}
              </form>
            </div>}

            {allPermiss?.includes("master-item-materialtype-view") && <div className="w-full px-2 md:w-[75%]">
              <MaterialTypePageForm
                editBtn={editBtn}
                firstPageList={firstPageList}
                links={links}
                firstPage={firstPage}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                editDisable={editDisable}
              />
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
}
